
import {DataForm} from 'argo-js/src/view';

export class PwChange extends DataForm {

  constructor(config) {
    super($.extend({
      ui: {
        statusMessage: '.status-message',
        successText: '.alert-success'
      },
      errorMap: {
        PASSWORD_DOES_NOT_MATCH: {
          name: 'oldPassword',
          message: 'error.PASSWORD_DOES_NOT_MATCH'
        },
        PASSWORD_DOES_NOT_MATCH_RULES: {
          name: 'newPassword',
          message: 'error.PASSWORD_DOES_NOT_MATCH_RULES'
        },
        PASSWORD_MUST_NOT_BE_EQUAL_TO_OLD_PASSWORD: {
          name: 'newPassword',
          message: 'error.PASSWORD_MUST_NOT_BE_EQUAL_TO_OLD_PASSWORD'
        },
        PASSWORD_MUST_NOT_BE_EQUAL_TO_USERNAME: {
          name: 'newPassword',
          message: 'error.PASSWORD_MUST_NOT_BE_EQUAL_TO_USERNAME'
        }
      },
      credentials: {}
    }, config));
  }

  onSubmit(data) {
    this.config.credentials.username = this.app.user.get('fullname');

    this.submitData = data;
    data.username = this.config.credentials.username;
    delete data.passwordConfirm;

    if (this.config.credentials && this.config.credentials.password) {
      data.oldPassword = this.config.credentials.password;
    }
    return this.app.user.changePassword(data);
  }

  handleSuccess(...args) {
    this.config.credentials.password = this.submitData.newPassword;
    let a = [this.config.credentials, ...args];
    super.handleSuccess(...a);
  }

  onSuccess() {
    this.ui.successText.text(this.t('success.data'));
    this.ui.form.hide();
    this.ui.statusMessage.fadeIn(500);
  }

  onLogout(e) {
    e.preventDefault();
    this.app.user
      .logout()
      .then(() => this.app.toHome());
  }

  onReturnToReferer() {
    this.app.redirect(this.app.config.referrerUrl);
  }
}

